import { mapActions } from "vuex";

export const workspaceTechSitesLocalsMixin = {
  methods: {
    ...mapActions([
      "fetchAllWorkspaces",
      "GET_WORKSPACE_TECHNICAL_SITES_WITH_LOCALS",
      "SET_NETWORK_DIAGRAM_TECHNICAL_LOCAL_UUID",
      "SET_NETWORK_DIAGRAM_CLOSURE_UUID",
      "RESET_NETWORK_DIAGRAM_TECHNICAL_LOCAL_UUID",
      "SET_NETWORK_DIAGRAM_WORKSPACE_UUID",
      "GET_WORKSPACE_CLOSURES",
      "GET_WORKSPACE_TECHNICAL_LOCAL_CLOSURES"
    ]),

    loadTechnicalSitesOptions(workspaceUUID) {
      this.GET_WORKSPACE_TECHNICAL_SITES_WITH_LOCALS(workspaceUUID).then(
        options => {
          return options;
        }
      );
    },

    /**
     * Transforms the list of Technical Sites with Technical Locals from the store into a list of options the
     * treeselect component can read.
     */
    getTechnicalSitesWithLocalsOptions(tsWithTl) {
      let options = [];
      if (tsWithTl) {
        let nrTs = tsWithTl.length;
        for (let tsIndex = 0; tsIndex < nrTs; tsIndex++) {
          let ts = tsWithTl[tsIndex];
          if (
            ts.hasOwnProperty("technicallocals") &&
            ts.technicallocals.length > 0
          ) {
            let newTs = this.createTechnicalSiteOption(ts);
            newTs.children = this.createListOfTechnicalLocalsOptions(ts);
            options.push(newTs);
          }
        }
      }
      return options;
    },

    /**
     * Transforms the list of Closures from the store into a list of options the
     * treeselect component can read.
     */
    getClosuresOptions(cls) {
    let options = [];
      if (cls) {
        let nrTs = cls.length;
        for (let clIndex = 0; clIndex < nrTs; clIndex++) {
            let cl = cls[clIndex];
            let newCl = this.createClosureOption(cl);
            options.push(newCl);
        }
      }
      return options;
    },

    getSpecificTypeOfTechnicalSiteLocalOptions(technicalSiteLocalOptions) {
      let specificTypeOfTechnicalSiteLocalOptions = [];
      technicalSiteLocalOptions.forEach(option => {
        specificTypeOfTechnicalSiteLocalOptions.push(option);
      });
      return specificTypeOfTechnicalSiteLocalOptions;
    },

    /**
     * Creates a Technical site object that the treeselect component can read as an option.
     * @param {object} ts - Original Technical site object
     * @return {object} the adapted object
     */
    createTechnicalSiteOption(ts) {
      let newTechnicalSite = {};
      newTechnicalSite.id = ts.ts_uuid;
      let tsType;
      if (ts.ts_logical_type === "OLT") {
        tsType = "CO";
      } else {
        tsType = "PN";
      }
      newTechnicalSite.label = tsType + ": ";
      if (ts.ts_label) {
        newTechnicalSite.label += ts.ts_label;
      } else {
        newTechnicalSite.label += ts.ts_id;
      }
      newTechnicalSite.children = [];
      return newTechnicalSite;
    },

    createClosureOption(ts) {
      let closure = {};
      closure.id = ts.cl_uuid;
      if (ts.cl_label) {
        closure.label = ts.cl_label;
      } else {
        closure.label = ts.cl_id;
      }
      return closure;
    },

    createListOfTechnicalLocalsOptions(ts) {
      let nrChildren = ts.technicallocals.length;
      let tlList = [];
      for (let tlIndex = 0; tlIndex < nrChildren; tlIndex++) {
        let tl = ts.technicallocals[tlIndex];
        let newTl = this.createTechnicalLocalOption(tl);
        tlList.push(newTl);
      }
      return tlList;
    },

    /**
     * Creates a Technical local object that the treeselect component can read as an option.
     * @param {object} tl - Original Technical local object
     * @return {object} the adapted object
     */
    createTechnicalLocalOption(tl) {
      let newTl = {};
      newTl.id = tl.tl_uuid;
      newTl.label = tl.tl_technical_site_logical_type + ": ";
      if (tl.tl_label) {
        newTl.label += tl.tl_label;
      } else {
        newTl.label += tl.tl_id;
      }
      return newTl;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/workspaceTechSitesLocalsMixin.js